export default "__VITE_ASSET__Bnh6JXU8__"